import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileTextControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
    }

}

const mobileTextControlView = new MobileTextControlView();
export default mobileTextControlView;